import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { Dolor } from './components/Dolor';
import { Producto } from './components/Producto';
import { Bonos } from './components/Bonos';
import { Pricing } from './components/Pricing';
// Sections BELOW the checkout are code-split so the hero paints first
// and the initial JS bundle stays small. Sections ABOVE the checkout are
// loaded eagerly so the page height is stable and the "#precio" anchor
// always lands exactly on the checkout.
const EliteUpsell = lazy(() => import('./components/EliteUpsell').then(m => ({
  default: m.EliteUpsell
})));
const Comparativa = lazy(() => import('./components/Comparativa').then(m => ({
  default: m.Comparativa
})));
const Testimonios = lazy(() => import('./components/Testimonios').then(m => ({
  default: m.Testimonios
})));
const Garantia = lazy(() => import('./components/Garantia').then(m => ({
  default: m.Garantia
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
// Reserve vertical space for not-yet-loaded sections to avoid layout shift.
const SectionFallback = () => <div className="min-h-[400px]" aria-hidden="true" data-id="element-0" />;
// content-visibility lets the browser skip rendering work for offscreen
// sections, which keeps scrolling smooth on long pages.
const Deferred = ({
  children
}: {
  children: React.ReactNode;
}) => <div className="[content-visibility:auto] [contain-intrinsic-size:1px_700px]" data-id="element-1">
    {children}
  </div>;
export function App() {
  return <div className="min-h-screen w-full bg-f360-bg font-sans selection:bg-f360-green selection:text-white" data-id="element-2">
      <Hero data-id="element-3" />
      <Dolor data-id="element-4" />
      <Producto data-id="element-5" />
      <Bonos data-id="element-6" />
      <Pricing data-id="element-7" />

      <Suspense fallback={<SectionFallback data-id="element-9" />} data-id="element-8">
        <Deferred data-id="element-10">
          <EliteUpsell data-id="element-11" />
        </Deferred>
        <Deferred data-id="element-12">
          <Comparativa data-id="element-13" />
        </Deferred>
        <Deferred data-id="element-14">
          <Testimonios data-id="element-15" />
        </Deferred>
        <Deferred data-id="element-16">
          <Garantia data-id="element-17" />
        </Deferred>
        <Deferred data-id="element-18">
          <FAQ data-id="element-19" />
        </Deferred>
        <Footer data-id="element-20" />
        <PurchasePopup data-id="element-21" />
      </Suspense>
    </div>;
}